Ext.define('ViewGPSPojazdyMobile', {
    extend: 'Ext.panel.Panel',
    grid: null,
    windowObject: null,
    id: "gpspojazdy",
    taskContextMenu: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    statics: {
        accessPropertyViewName: "access.view.gpspojazdy"
    },
    cat: "p",
    text: Lang.gps_pojazdy,
    buttonIconCls: "iconGpsPojazd",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px',
                cls: "kontekstfirmy-text"
            }, {
                xtype: 'tbseparator',
                hidden: (!Const.BASICFLAG && !Const.STANDARDFLAG) || Const.LICENCE.SERVER_LIMITOFF_KDPANDID
            }, {
                xtype: 'label',
                hidden: (!Const.BASICFLAG && !Const.STANDARDFLAG) || Const.LICENCE.SERVER_LIMITOFF_KDPANDID,
                id: this.id + 'idcount-text'
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
        if (this.grid && this.grid.rendered)
            this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        this.refreshDatastore();
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        if (this.rebuildGrid) {
            this.rebuildGrid = false;
            var onwer = this.grid.ownerCt;
            Ext.suspendLayouts();
            onwer.remove(this.grid);
            this.grid.destroy();
            this.buildGrid();
            onwer.add(this.grid);
            Ext.resumeLayouts(true);
            if (this.grid && this.grid.rendered)
                this.grid.getDockedComponent(1).updatePageSize(getNumberOfVisibleRows(this.grid));
        }
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
    },
    scrollToView: function (id) {
        this.grid.selectRowScroll("id", id);
    },
    buildGrid: function (datals) {
        var store = new Ext.data.Store({
            autoLoad: false,
            remoteSort: true,
            remoteFilter: true,
            sorters: [{
                property: 'id',
                direction: "ASC"
            }],
            model: Ext.define(null, {
                extend: 'Ext.data.Model',
                idProperty: 'id',
                fields: [{
                    name: 'id',
                    mapping: 'id'
                }, {
                    name: 'externalid',
                    mapping: 'externalid'
                }, {
                    name: 'nazwa',
                    mapping: 'nazwa'
                }, {
                    name: 'opis',
                    mapping: 'opis'
                }, {
                    name: 'pojazd',
                    mapping: 'pojazd'
                }, {
                    name: 'lasteventgmt',
                    mapping: 'lasteventgmt',
                    type: 'date'
                }, {
                    name: 'pojazdlinked',
                    mapping: 'pojazdlinked'
                }]
            }),
            proxy: {
                type: 'ajax',
                url: 'rest/gpspojazdy/getList',
                filterParam: "filters",
                actionMethods: {
                    read: 'POST'
                },
                reader: {
                    type: 'json',
                    rootProperty: 'data',
                    totalProperty: 'total',
                    id: 'id'
                },
                listeners: {
                    scope: this,
                    exception: handlGridLoadExceptionJsonRpcL
                }
            },
            listeners: {
                scope: this,
                load: handlGridLoadStoreCheckJsonRpcL
            }
        })
        var cols = [{
            header: "ID",
            flex: 1,
            sortable: true,
            dataIndex: 'id',
            filter: {
                type: 'numeric'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            filterable: true
        }, {
            header: Lang.polaczony_z_pojazdem,
            flex: 1,
            sortable: true,
            dataIndex: 'pojazdlinked',
            renderer: renderBool3,
            filter: {
                type: 'boolean'
            },
            filterable: true
        }];
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true,
                rowexpander: {
                    rowBodyTpl: new Ext.XTemplate(
                        `<div class="mobile-rowexp-wrapper">
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.id_zewnetrzny}:
                                    <span class="mobile-rowexp-value"> {externalid}</span>
                                </span>
                            </div>

                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.nazwa}:
                                    <span class="mobile-rowexp-value"> {nazwa}</span>
                                </span>
                            </div>
                            
                            <div class="mobile-rowexp-row">
                                <span class="mobile-rowexp-title">${Lang.czas_ostatniego_pobranego_zdarzenia}:
                                    <span class="mobile-rowexp-value"> {lasteventgmt:this.czas}</span>
                                </span>
                            </div>

                            <tpl if="this.notEmptyAfterTrim(pojazd)">
                                <div class="mobile-rowexp-row">
                                    <span class="mobile-rowexp-title">${Lang.pojazd}:
                                        <span class="mobile-rowexp-value"> {pojazd}</span>
                                    </span>
                                </div>
                            </tpl>
                        
                            <tpl if="this.notEmptyAfterTrim(opis)">
                                <div class="mobile-rowexp-row">
                                    <span class="mobile-rowexp-title">${Lang.opis}:
                                        <span class="mobile-rowexp-value"> {opis}</span>
                                    </span>
                                </div>
                            </tpl>
                        </div>`,
                        {
                            notEmptyAfterTrim,
                            czas: Ext.util.Format.dateRenderer()
                        }
                    )
                }
            },
            store: store,
            columns: cols,
            frame: false,
            border: false,
            stateId: "grid-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            },
            bbar: {
                xtype: 'pagingtoolbarexd',
                displayInfo: true,
                pagingStore: store
            }
        });
    },
    refreshDatastore: function () {
        this.grid.store.load();
    }
});
